export default "__VITE_ASSET__0b58788d__"